import { Component, OnInit } from '@angular/core';
import { ModalComponent, modals } from '@clooper/modals';
// import { AddRoonModalComponent } from '../add-roon-modal/add-roon-modal.component';

@Component({
  selector: 'app-add-room-success-modal',
  templateUrl: './add-room-success-modal.component.html',
  styleUrls: ['./add-room-success-modal.component.scss']
})
export class AddRoomSuccessModalComponent extends ModalComponent implements OnInit {

  constructor() { 
    super()
  }

  ngOnInit(): void {
  }
  addAnotherRoom() {
    setTimeout(() => {
      // modals.launch(AddRoonModalComponent, {})
    }, 200);
  }

}
